



















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Share extends Vue {
  shareClassroomUrl(e: any) {
    e.preventDefault();
    this.$parent.$emit('share-classroom-url');
  }
}
